import { Injectable } from '@angular/core';

declare let $: any;

@Injectable()
export class AccessibilityService {
  public skipLinkId: any;
  
  focus(selector) {
    setTimeout(function () { $(selector).focus(); }, 150);
  }

  updateAttributeValue(selector, attr, value) {
    setTimeout(function () { $(selector).attr(attr, value); }, 100);
  }

  updateValue(selector, value) {
    setTimeout(function () { $(selector).val(value); }, 100);
  }

  updateHtmlStyle() {
    setInterval(function() {
      $('html').css('overflow', 'auto');
    }, 60000);
  }

  setSkipLinkId(id) {
    this.skipLinkId = id;
  }

  getSkipLinkId() {
    return this.skipLinkId;
  }
}
